<template>
  <el-calendar v-model="value"> </el-calendar>
</template>

<script>
import { formatDate } from "@/utils";

export default {
  components: {},
  data() {
    return {
      value: "",
    };
  },
  created() {},
  watch: {
    value: {
      handler(val) {
        this.$emit("dateTimeChange", [
          formatDate(val) + " 00:00:00",
          formatDate(val) + " 23:59:59",
        ]);
      },
      immidiate: true,
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.el-calendar {
  background: transparent;

  ::v-deep .el-calendar__header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }
  ::v-deep .el-calendar__title {
    color: rgba(255, 255, 255, 0.8);
  }
  ::v-deep .el-button {
    background: transparent;
    border-color: rgba(255, 255, 255, 0.3);
    color: rgba(255, 255, 255, 0.8);
    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }
  ::v-deep .el-calendar-table {
    color: rgba(255, 255, 255, 1);
    .el-calendar-day {
      text-align: center;
      height: auto;
      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
    td {
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      border-right: 1px solid rgba(255, 255, 255, 0.3);
      &.is-selected {
        background: rgba(55, 242, 245, 0.3);
        color: #fff;
      }
      &.is-today {
        color: rgb(58, 232, 247);
        font-weight: bold;
      }
    }
    tr td:first-child {
      border-left: 1px solid rgba(255, 255, 255, 0.3);
    }
    tr:first-child td {
      border-top: 1px solid rgba(255, 255, 255, 0.3);
    }
    &:not(.is-range) td.prev,
    &:not(.is-range) td.next {
      color: rgba(255, 255, 255, 0.5);
    }
    th {
      color: rgba(255, 255, 255, 0.8);
    }
  }
}
</style>
